import { render, staticRenderFns } from "./DataApproval.vue?vue&type=template&id=510a0d13&scoped=true"
import script from "./DataApproval.vue?vue&type=script&lang=js"
export * from "./DataApproval.vue?vue&type=script&lang=js"
import style0 from "./DataApproval.vue?vue&type=style&index=0&id=510a0d13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a0d13",
  null
  
)

export default component.exports